<template>
  <div class="display-flex height-percent-100">
    <div class="risk-point">
      <div class="display-flex ai-center jc-space-between mb-20">
        <b class="fs-18">风险点列表(共{{ fxPointerTotal }}条)</b>
        <el-button
          type="text"
          icon="el-icon-plus"
          class="padding-0"
          @click="addfxPointer"
          >风险点</el-button
        >
      </div>
      <div class="risk-point-filters">
        <el-select
          clearable
          size="small"
          placeholder="风险点类型"
          class="width-percent-100"
          @change="searchfxPointer"
          v-model="fxPointerSearchForm.type"
        >
          <el-option
            v-for="item in option.riskPtType"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          @change="searchfxPointer"
          size="small"
          placeholder="行业分类"
          class="width-percent-100"
          v-model="fxPointerSearchForm.industryIds"
        >
          <el-option
            v-for="item in option.industryType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-input
        v-model="fxPointerSearchForm.name"
        placeholder="请输入风险点"
        clearable
        size="small"
        @input="searchfxPointer"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        风险点
      </el-input>
      <div class="fsPointList scrollbar-y" style="height: calc(100vh - 350px)">
        <el-scrollbar v-if="fxPointerList.length" ref="scrollbar">
          <div
            v-infinite-scroll="getRiskPointList"
            :infinite-scroll-disabled="scrollDisabled"
          >
            <div
              class="item"
              @click="selectedRisk = item"
              :class="{ diyActive: selectedRisk.id === item.id }"
              v-for="(item, index) in fxPointerList"
              :key="index"
            >
              <div class="display-flex jc-space-between ai-center">
                <div class="fs-16 flex-4">{{ item.name }}</div>
                <el-divider direction="vertical"></el-divider>
                <div class="flex-1">
                  <i
                    class="el-icon-edit color-primary mr-14"
                    @click="editfxPointer(item)"
                  ></i>
                  <i
                    class="el-icon-delete color-danger"
                    @click="delfxPoint([item.id])"
                  ></i>
                </div>
              </div>
              <p class="fs-14 color-info">
                风险点类型：{{ item.fxTypeName || "--" }}
              </p>
              <p class="fs-14 color-info">
                行业分类：{{ item.fxIndustryName || "--" }}
              </p>
              <div class="display-flex">
                <span class="fs-14 color-info">警示标志：</span>
                <div class="scrollbar-x display-flex">
                  <div
                    v-for="(_item, index) in item.fxWarnSignUrlList || []"
                    :key="index"
                  >
                    <img
                      width="40"
                      height="40"
                      :src="_item"
                      alt=""
                      class="mr-8"
                    />
                  </div>
                </div>
              </div>
              <i
                v-if="selectedRisk.id === item.id"
                class="el-icon-check selected-check"
                aria-hidden="true"></i>
            </div>
          </div>
          <p class="ta-center fs-14 color-info" v-if="scrollLoading">
            加载中...
          </p>
          <p class="ta-center fs-14 color-info" v-if="scrollNoMore">
            没有更多了
          </p>
          <p class="ta-center fs-14 color-info" v-else>下拉加载更多</p>
        </el-scrollbar>
        <el-empty v-else :image-size="100" description="暂无数据"></el-empty>
      </div>
    </div>
    <div class="content">
      <div class="risk-content-header">
        <span class="risk-content-title">当前风险点：{{ selectedRisk && selectedRisk.name }}</span>
        <div class="risk-content-actions">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="add"
            >危险有害因素</el-button
          >
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            :disabled="!selection.length"
            @click="delRow(selection)"
            >批量删除</el-button
          >
        </div>
      </div>
      <el-form :inline="true" size="small" v-model="searchForm">
        <el-form-item label="">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入危险有害因素"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select
            class="width-140"
            clearable
            placeholder="风险等级"
            v-model="searchForm.level"
          >
            <el-option
              v-for="item in option.riskGrade"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-search" @click="getTableData">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetHarmSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-scrollbar style="height: calc(100vh - 300px)" class="padding-20">
        <el-table
          :cell-class-name="cellClassName"
          border
          :data="tableData"
          @selection-change="
            (val) => {
              selection = val;
            }
          "
        >
          <el-table-column fixed align="center" type="selection" width="55">
          </el-table-column>
          <el-table-column
            fixed
            prop="harmFactor"
            width="180"
            label="危险有害因素"
          >
          </el-table-column>
          <el-table-column align="center" prop="name" width="80" label="状态">
            <template #default="{ row }">
              <!-- 1正常、2异常、3紧急 -->
              <el-tag type="success" v-if="row.state == '1'">正常</el-tag>
              <el-tag type="warning" v-if="row.state == '2'">异常</el-tag>
              <el-tag type="danger" v-if="row.state == ' 3'">紧急</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" width="80" label="时态">
            <template #default="{ row }">
              <!-- 1过去、2现在、3将来 -->
              <el-tag type="info" v-if="row.tense === 1">过去</el-tag>
              <el-tag v-if="row.tense === 2">现在</el-tag>
              <el-tag type="success" v-if="row.tense === 3">将来</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="fxAccidentTypeNameList"
            width="100"
            label="事故类型"
          >
            <template #default="slotProps">
              {{ slotProps.row.fxAccidentTypeNameList.join() }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            width="160"
            label="风险等级"
            class-name="risk-level-cell"
          >
            <template #default="slotProps">
              <div
                class="color-white display-flex ai-center jc-space-between padding-20 pt-12 pb-12 cursor-pointer fs-14"
                :style="{ background: gradeBgColor(slotProps.row.level.level) }"
              >
                <p class="margin-0">
                  {{ slotProps.row.level.level | gradeName }}
                </p>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div
                class="display-flex pl-20"
                style="min-height: 60px"
                :style="{
                  height: `${slotProps.row.measureRows * 40 + 50}px`,
                  background: levelSubColor(slotProps.row.level.level),
                }"
              >
                <div
                  v-if="slotProps.row.level.type === '1'"
                  class="fs-12 display-flex fd-column ai-flex-start pt-6"
                >
                  <b>直接判断法</b>
                </div>
                <div
                  v-if="slotProps.row.level.type === '2'"
                  class="fs-12 display-flex fd-column ai-flex-start pt-6"
                >
                  <b>LS法：</b> R=L×S
                  {{ slotProps.row.level.L * slotProps.row.level.S }}={{
                    slotProps.row.level.L
                  }}×{{ slotProps.row.level.S }}
                </div>
                <div
                  v-if="slotProps.row.level.type === '3'"
                  class="fs-12 display-flex fd-column ai-flex-start pt-6"
                >
                  <b>LEC法：</b> D=L×E×C
                  {{
                    slotProps.row.level.L *
                    slotProps.row.level.E *
                    slotProps.row.level.C
                  }}={{ slotProps.row.level.L }}×{{ slotProps.row.level.E }}×{{
                    slotProps.row.level.C
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            width="80"
            label="风险代码"
          >
            <template #default="{ row }">
              {{ row.fxCode }}
            </template>
          </el-table-column>
          <el-table-column width="500" label="管控措施">
            <template #default="slotProps">
              <div v-if="slotProps.row.measures.length">
                <div
                  v-for="(item, index) in slotProps.row.measures"
                  :key="index"
                  :class="{ 'mt-10': index }"
                  class="display-flex ai-flex-start padding-10 mt-10"
                  style="border: 1px solid #e5e5e5"
                >
                  <div class="display-flex ai-center">
                    <img width="14px" class="mr-6" :src="item.icon" alt="" />
                    <b style="width: 100px; display: block">{{ item.title }}</b>
                  </div>
                  <div class="risk-measure-items flex-1">
                    <div
                      v-for="(_item, _index) in item.list"
                      :key="_item.id || _index"
                      class="risk-measure-entry"
                    >
                      <el-tooltip
                        :content="_item.name"
                        placement="top"
                        effect="dark"
                        popper-class="risk-measure-tooltip"
                      >
                        <el-button
                          type="text"
                          class="risk-measure-entry-text"
                          @click="openMeasureDetail(slotProps.row.allMeasures)"
                        >{{ _item.name }}</el-button>
                      </el-tooltip>
                      <i
                        class="el-icon-document-copy color-primary cursor-pointer ml-8"
                        title="复制"
                        @click.stop="copyMeasureText(_item.name)"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>暂无管控措施</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="editRow(scope.row)"
                type="text"
                class="color-primary"
                >编辑</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                @click="delRow([scope.row])"
                type="text"
                class="color-danger"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
      <div class="display-flex fd-row-reverse mt-20">
        <!-- 表格数据的分页的功能 -->
        <el-pagination
          hide-on-single-page
          @current-change="
            (val) => {
              searchForm.pageNum = val;
            }
          "
          :current-page="searchForm.pageNum"
          :page-size="searchForm.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="tableNum"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      v-if="dialogRiskPoint.show"
      :title="dialogRiskPoint.title"
      :visible.sync="dialogRiskPoint.show"
      width="700px"
      top="6vh"
    >
      <el-form
        ref="dialogForm"
        class="diy-top-form"
        :model="dialogRiskPoint.form"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          label="风险点名称:"
          prop="name"
          :rules="{ required: true, message: '请输入名称', trigger: 'blur' }"
        >
          <el-input
            v-model="dialogRiskPoint.form.name"
            placeholder="请输入名称"
            class="width-percent-80"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="风险点类型">
          <el-select
            size="small"
            clearable
            class="width-percent-80"
            placeholder="标识类型"
            v-model="dialogRiskPoint.form.type"
          >
            <el-option
              v-for="item in option.riskPtType"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="行业分类:"
          prop="industryId"
          :rules="{
            required: true,
            message: '请选择上级部门',
            trigger: 'change',
          }"
        >
          <el-cascader
            class="width-percent-80"
            size="small"
            placeholder="行业分类多选"
            v-model="dialogRiskPoint.form.industryId"
            :options="option.industryType"
            clearable
            :props="{
              expandTrigger: 'hover',
              emitPath: false,
              checkStrictly: true,
              label: 'name',
              value: 'id',
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="警示标志：">
          <div style="border: 1px solid #e9e9e9">
            <div class="display-flex">
              <p
                @click="changeIconType(item)"
                v-for="item in iconTypeList"
                :key="item.id"
                class="width-100 cursor-pointer ta-center"
                :class="{
                  'active-icon-type': dialogRiskPoint.form.warnType === item.id,
                }"
              >
                {{ item.name }}
              </p>
              <el-input
                class="flex-2 mr-10 display-flex ai-center"
                placeholder="标识名称"
                clearable
                size="small"
                @input="getIconList"
                v-model="dialogRiskPoint.searchForm.name"
                ><i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <el-divider></el-divider>
            <div class="padding-20 scrollbar-y">
              <el-scrollbar style="height: 200px" v-if="fxWarnSignList.length">
                <div class="imgList">
                  <div
                    @click="changeSelectIcon(item)"
                    :class="{ active: item.selected }"
                    class="item"
                    v-for="item in fxWarnSignList"
                    :key="item.id"
                  >
                    <div class="display-flex ai-center fd-column">
                      <img width="80" height="80" :src="item.imgUrl" alt="" />
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
              <el-empty
                v-else
                :image-size="100"
                description="暂无数据"
              ></el-empty>
            </div>
            <div
              class="height-80 padding-10 pl-20 display-flex"
              style="border-top: 1px solid #e6e6e6"
            >
              <p class="fs-14 width-60">已选择：</p>
              <div class="scrollbar-x flex-1 display-flex">
                <div
                  @click="delSelectedIcon(item)"
                  v-for="item in dialogRiskPoint.form.selIconList"
                  :key="item.id"
                  class="padding-10 cursor-pointer selected-icon"
                >
                  <img width="60" height="60" :src="item.imgUrl" alt="" />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitForm" :loading="loading"
          >确认</el-button
        >
        <el-button @click="dialogRiskPoint.show = false">取消</el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="管控措施详情"
      :visible.sync="measureDetail.show"
      width="520px"
      append-to-body
    >
      <div class="measure-detail-list">
        <div
          v-for="(group, groupIndex) in measureDetail.list"
          :key="group.title || groupIndex"
          class="measure-detail-group"
        >
          <b>{{ group.title }}</b>
          <div v-if="group.list.length">
            <div
              v-for="(_item, index) in group.list"
              :key="_item.id || index"
              class="display-flex ai-flex-start mt-10"
            >
              <span class="flex-1 measure-detail-text">{{ _item.name }}</span>
              <i
                class="el-icon-document-copy color-primary cursor-pointer ml-8"
                title="复制"
                @click="copyMeasureText(_item.name)"
              ></i>
            </div>
          </div>
          <div v-else class="color-info mt-10">暂无措施</div>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" @click="measureDetail.show = false">关闭</el-button>
      </span>
    </el-dialog>
    <HarmAddDialog
      v-if="harmDialogshow"
      :show.sync="harmDialogshow"
      :selectedRisk="selectedRisk"
      :operate-type="operateType"
      @close="(val) => { harmDialogshow = val}"
      @refreshData="getTableData"
      :id="harmItemId"
    >
    </HarmAddDialog>
  </div>
</template>
<script>
import _ from 'lodash';
// import icon1 from '@/assets/images/risk/icon1.png'
// import icon2 from '@/assets/images/risk/icon2.png'
// import icon3 from '@/assets/images/risk/icon3.png'
// import icon4 from '@/assets/images/risk/icon4.png'
// import icon5 from '@/assets/images/risk/icon5.png'
import HarmAddDialog from '@/views/basicLibrary/risk/HarmAddDialog';
export default {
  name: 'index',
  components: { HarmAddDialog },
  props: {},
  data () {
    return {
      harmItemId: '',
      scrollLoading: false,
      searchStatus: false,
      rowData: {},
      harmDialogshow: false,
      operateType: '',
      tableNum: 0,
      fxPointerTotal: 0,
      importDialog: {
        show: false,
        form: {
          file: []
        }
      },
      loading: false,
      option: {
        industryType: [], // 行业分类
        riskPtType: [], // 风险点类型
        riskGrade: [], // 风险等级
        accidentType: [] // 事故类型
      },
      iconTypeList: [], // 警示标志类型列表
      fxWarnSignList: [], // 某个警示标识类型下的列表数据
      fxPointerList: [],
      fxPointerSearchForm: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        name: '', // 风险点搜索
        industryIds: []
      },
      selectedRisk: null, // 选择的风险点
      searchForm: {
        name: '',
        level: '',
        pageNum: 1,
        pageSize: 50
      },
      selection: [],
      tableData: [],
      dialogRiskPoint: {
        title: '添加风险点',
        show: false,
        form: {
          id: '',
          name: '',
          type: '', // 风险点类型
          industryId: '',
          selIconList: [], // 选中的警示标志项
          warnType: '' // 选择的警示标志类型
        },
        searchForm: {
          name: '',
          type: '1'
        }
      }, // 风险点drawer
      drawer: {
        title: '添加危险有害因素',
        show: false,
        form: {
          id: '',
          name: '',
          type: [],
          level: null,
          measures: []
        }
      },
      measureDetail: {
        show: false,
        list: []
      }
    };
  },
  filters: {
    gradeName (val) {
      switch (val) {
        case '4':
          return '重大风险';
        case '3':
          return '较大风险';
        case '2':
          return '一般风险';
        case '1':
          return '低风险';
      }
    }
  },
  computed: {
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm));
    },
    scrollNoMore () {
      return (
        this.fxPointerTotal <=
        this.fxPointerSearchForm.pageNum * this.fxPointerSearchForm.pageSize
      );
    },
    scrollDisabled () {
      return this.scrollLoading || this.scrollNoMore;
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.pageNum !== 1 && newVal.pageNum === oldVal.pageNum) {
          this.searchForm.pageNum = 1;
        } else {
          this.getTableData();
        }
      },
      deep: true
    },
    selectedRisk () {
      this.getTableData();
    }
  },
  methods: {
    openMeasureDetail (measures) {
      this.measureDetail.list = measures
      this.measureDetail.show = true
    },
    copyMeasureText (text) {
      this.$copyText(String(text)).then(() => {
        this.$message.success('已复制')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    resetHarmSearch () {
      this.searchForm.name = ''
      this.searchForm.level = ''
      this.searchForm.pageNum = 1
      this.getTableData()
    },
    submitImport () {
      if (this.importDialog.form.file.length) {
        const data = new FormData();
        data.append('file', this.importDialog.form.file[0]);
        const loading = this.$loading({
          lock: true,
          text: '上传中,请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api.riskLibrary
          .submitImport(data)
          .then((res) => {
            this.$message.success('上传成功');
            this.importDialog.show = false;
            loading.close();
            this.getRiskPointList();
          })
          .catch(() => {
            loading.close();
          });
      } else {
        this.$message.warning('请上传文件');
      }
    },
    cellClassName (data) {
      if (data.columnIndex === 3) {
        return 'no-padding';
      }
    },
    /**
     * 添加风险点
     */
    addfxPointer () {
      this.dialogRiskPoint = {
        title: '添加风险点',
        show: true,
        form: {
          id: '',
          name: '',
          type: '',
          industryId: '',
          selIconList: [],
          warnType: '1'
        },
        searchForm: {
          name: ''
        }
      };
      this.getIconList();
    },
    /**
     * 编辑风险点
     * @param data
     */
    editfxPointer (item) {
      console.log(item);
      this.dialogRiskPoint.form = {
        id: item.id,
        name: item.name,
        type: item.fxTypeId,
        industryId: item.fxIndustryId,
        warnType: '1',
        selIconList: item.fxWarnSignUrlList
          ? item.fxWarnSignUrlList.map((_item, index) => {
            return {
              id: item.fxWarnSignIdList[index],
              imgUrl: _item
            };
          })
          : []
      };
      this.getIconList(item);
      this.dialogRiskPoint.title = '编辑风险点';
      this.dialogRiskPoint.show = true;
    },
    /**
     * 删除风险点
     * @param id
     */
    delfxPoint (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.riskLibrary.fxDel(id).then((res) => {
            this.$message.success('删除成功');
            this.$nextTick(() => {
              this.searchfxPointer();
            });
          });
        })
        .catch(() => {});
    },
    /**
     * 提交风险点
     */
    submitForm () {
      const data = {
        fxIndustryId: this.dialogRiskPoint.form.industryId || '',
        fxTypeId: this.dialogRiskPoint.form.type || '',
        fxWarnSignIdList:
          this.dialogRiskPoint.form.selIconList.map((item) => item.id) || [],
        name: this.dialogRiskPoint.form.name
      };
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.dialogRiskPoint.form.id) {
            data.id = this.dialogRiskPoint.form.id;
            this.$api.riskLibrary
              .fxUpdate(data)
              .then((res) => {
                this.$message.success('编辑成功');
                this.loading = false;
                this.dialogRiskPoint.show = false;
                this.searchfxPointer();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$api.riskLibrary
              .fxSave(data)
              .then((res) => {
                this.$message.success('创建成功');
                this.loading = false;
                this.dialogRiskPoint.show = false;
                this.searchfxPointer();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    /**
     * 切换警示标志类型
     * @param id
     */
    changeIconType (item) {
      console.log(item);
      this.dialogRiskPoint.form.warnType = item.id;
      this.getIconList(); // 这个要改下 获取之后进行筛选出要选择的
    },
    /**
     * 选中标识的方法
     * @param data
     */
    changeSelectIcon (data) {
      console.log(data);
      data.selected = !data.selected;
      if (data.selected) {
        this.dialogRiskPoint.form.selIconList.push(data);
      } else {
        this.dialogRiskPoint.form.selIconList =
          this.dialogRiskPoint.form.selIconList.filter(
            (item) => item.id !== data.id
          );
      }
    },
    /**
     * 删除已经选择的标识
     * @param data
     */
    delSelectedIcon (data) {
      if (this.fxWarnSignList.filter((item) => item.id === data.id).length) {
        this.fxWarnSignList.filter(
          (item) => item.id === data.id
        )[0].selected = false;
      }
      this.dialogRiskPoint.form.selIconList =
        this.dialogRiskPoint.form.selIconList.filter(
          (item) => item.id !== data.id
        );
    },
    /**
     *获取警示标志列表
     */
    getIconList: _.debounce(function (rowData) {
      this.dialogRiskPoint.iconList = [];
      const ids = this.dialogRiskPoint.form.selIconList.map(
        (_item) => _item.id
      );
      const data = {
        pageNum: 1,
        pageSize: 999,
        name: this.dialogRiskPoint.searchForm.name,
        fxWarnSignTypeId: this.dialogRiskPoint.form.warnType
      };
      this.$api.iconLibrary.list(data).then((res) => {
        this.fxWarnSignList = res.list.map((item) => {
          return {
            ...item,
            selected: ids.includes(item.id)
          };
        });
        console.log(this.fxWarnSignList);
      });
    }, 500),

    /**
     * 风险等级对应颜色
     * @param id
     * @returns {string}
     */
    gradeBgColor (id) {
      switch (id) {
        case '4':
          return '#FF4A4A';
        case '3':
          return '#F6B300';
        case '2':
          return '#F9E14A';
        case '1':
          return '#326BFF';
      }
    },
    /**
     * 风险等级对应副系颜色
     * @param id
     * @returns {string}
     */
    levelSubColor (id) {
      switch (id) {
        case '4':
          return '#FFF0F0';
        case '3':
          return '#FFFAEB';
        case '2':
          return '#FFFEF6';
        case '1':
          return '#EAF0FF';
      }
    },

    /**
     * 添加管控措施
     * @param data
     */
    addMeasure (data) {
      const id = Math.floor(Math.random() * 10) + this.$moment().unix();
      if (data.list.length) {
        if (data.list[data.list.length - 1].name) {
          data.list.push({
            name: '',
            id
          });
          this.$nextTick(() => {
            this.$refs[id][0] && this.$refs[id][0].focus(); // 获取输入框，自动获取焦点
          });
        } else {
          this.$message.warning('请先填写完成上一条管控措施');
        }
      } else {
        data.list.push({
          name: '',
          id
        });
        this.$nextTick(() => {
          this.$refs[id][0] && this.$refs[id][0].focus();
        });
      }
    },
    /**
     * 删除管控措施
     * @param data
     */
    delMeasure (item, _item) {
      item.list = item.list.filter((__item) => __item.id !== _item.id);
    },
    /**
     * 添加危险有害因素
     */
    add () {
      this.harmDialogshow = true;
      this.operateType = 'add'
      this.harmItemId = ''
    },
    /**
     * 编辑危险有害因素
     * @param row
     */
    editRow (row) {
      this.harmDialogshow = true;
      this.operateType = 'edit';
      this.harmItemId = row.id;
      // this.rowData = {
      //   id: row.id,
      //   name: row.harmFactor,
      //   typeList: row.fxAccidentTypeIdList,
      //   level: JSON.parse(row.decisionMethodValue),
      //   measures: row.measures ? row.measures : [
      //     {
      //       icon: icon4,
      //       title: '工程技术措施：',
      //       list: []
      //     },
      //     {
      //       icon: icon3,
      //       title: '管理方法措施：',
      //       list: []
      //     },
      //     {
      //       icon: icon2,
      //       title: '教育培训措施：',
      //       list: []
      //     },
      //     {
      //       icon: icon5,
      //       title: '个体防护措施：',
      //       list: []
      //     },
      //     {
      //       icon: icon1,
      //       title: '应急处置措施：',
      //       list: []
      //     }
      //   ]
      // }
      // this.drawerLevel.form.active = JSON.parse(row.decisionMethodValue).type
      // this.drawerLevel.form.method1Value = JSON.parse(row.decisionMethodValue).level
      // this.drawerLevel.form.method2.L = JSON.parse(row.decisionMethodValue).L
      // this.drawerLevel.form.method2.S = JSON.parse(row.decisionMethodValue).S
      // this.drawerLevel.form.method3.L = JSON.parse(row.decisionMethodValue).L
      // this.drawerLevel.form.method3.E = JSON.parse(row.decisionMethodValue).E
      // this.drawerLevel.form.method3.C = JSON.parse(row.decisionMethodValue).C
    },
    /**
     * 删除危险有害因素
     * @param data
     */
    delRow (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.riskLibrary
            .harmFactorDel(data.map((item) => item.id))
            .then((res) => {
              this.$message.success('删除成功');
              this.getTableData();
            });
        })
        .catch(() => {});
    },
    /**
     * 提交添加危险有害因素
     */
    submitDrawer () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const list = [];
          let flag = false;
          this.drawer.form.measures.forEach((item) => {
            item.list.forEach((_item) => {
              if (_item.name.trim || _item.name !== '') {
                list.push(_item);
              }
              if (_item.name.trim() && item.name !== '') {
                flag = true;
              }
            });
          });
          if (flag) {
            const data = {
              decisionMethodValue: JSON.stringify(this.drawer.form.level),
              fxAccidentTypeIds: this.drawer.form.type,
              fxDbId: this.selectedRisk.id,
              fxDecisionMethodId: this.drawer.form.level.type,
              fxGradeId: this.drawer.form.level.level,
              harmFactor: this.drawer.form.name,
              measure: JSON.stringify(this.drawer.form.measures)
            };
            if (this.drawer.form.id) {
              data.id = this.drawer.form.id;
              this.$api.riskLibrary.harmFactorUpdate(data).then((res) => {
                this.$message.success('编辑成功');
                this.drawer.show = false;
                this.getTableData();
              });
            } else {
              this.$api.riskLibrary.harmFactorSave(data).then((res) => {
                this.$message.success('添加成功');
                this.drawer.show = false;
                this.searchForm.pageNum = 1;
                this.getTableData();
              });
            }
          } else {
            this.$message.warning('请至少填写一项管控措施');
          }
        }
      });
    },
    searchfxPointer () {
      this.fxPointerSearchForm.pageNum = 1;
      this.fxPointerList = [];
      this.fxPointerTotal = 0;
      this.getRiskPointList();
    },
    /**
     * 获取风险点列表
     */
    getRiskPointList: _.debounce(function () {
      const data = {
        fuzzy: this.fxPointerSearchForm.name,
        fxIndustryId: this.fxPointerSearchForm.industryIds,
        fxTypeId: this.fxPointerSearchForm.type,
        pageNum: this.fxPointerSearchForm.pageNum,
        pageSize: this.fxPointerSearchForm.pageSize
      };
      this.scrollLoading = true;
      this.$api.riskLibrary
        .fxList(data)
        .then((res) => {
          if (this.fxPointerSearchForm.pageNum === 1) {
            this.fxPointerList = res.list || [];
          } else {
            this.fxPointerList.push(...res.list);
          }
          this.fxPointerSearchForm.pageNum++;
          this.fxPointerTotal = res.total;
          this.scrollLoading = false;
          if (this.fxPointerList.length) {
            this.selectedRisk = this.fxPointerList[0];
          }
          this.$nextTick(() => {
            this.$refs.scrollbar.update();
          });
        })
        .catch(() => {
          this.scrollLoading = false;
        });
    }, 500),
    /**
     * 危险有害因素列表
     */
    getTableData: _.debounce(function () {
      const data = {
        fxGradeId: this.searchForm.level,
        fxDbId: this.selectedRisk.id,
        fuzzy: this.searchForm.name,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      this.$api.riskLibrary.harmFactorList(data).then((res) => {
        this.tableData = res.list.map((item) => {
          const measures = item.measure ? JSON.parse(item.measure) : []
          return {
            ...item,
            level: JSON.parse(item.decisionMethodValue),
            allMeasures: measures,
            measures: measures.filter((i) => i.list.length),
            measureRows: measures.reduce((total, group) => total + group.list.length, 0)
          };
        });
        console.log('this.tableData', this.tableData);
        this.tableNum = res.total;
      });
    }, 500)
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    // 获取风险点列表
    this.getRiskPointList();
    // 获取风险等级列表
    this.$api.riskLibrary.getRiskGradeList().then((res) => {
      this.option.riskGrade = res;
    });
    // 获取行业类型列表
    this.$api.riskLibrary.getIndustryTypeList().then((res) => {
      this.option.industryType = res;
    });
    // 获取风险点类型列表
    this.$api.riskLibrary.getRiskPtTypeList().then((res) => {
      this.option.riskPtType = res;
    });
    this.$api.iconLibrary.type().then((res) => {
      this.iconTypeList = res;
    });
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {}
};
</script>

<style lang="scss" scoped>
.risk-point {
  width: 330px;
  overflow: hidden;
  margin-right: 16px;
  background-color: white;
  padding: 20px;
  .fsPointList {
    margin-top: 12px;
    .item {
      padding: 20px;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      width: 280px;
      cursor: pointer;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .diyActive {
      border: 1px solid #328fff;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        height: 20px;
        background: #1774ff;
        clip-path: polygon(0 0, 100% 0, 100% 100%);
      }
      .selected-check {
        position: absolute;
        top: 1px;
        right: 1px;
        color: #fff;
        font-size: 9px;
        font-weight: 700;
      }
    }
  }
}

.risk-point-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.content {
  flex: 1;
  overflow: hidden;
  background-color: white;
  padding: 30px 20px;
}
.risk-content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 16px;
}
.risk-content-title {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 16px;
}
.risk-content-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  ::v-deep .el-button {
    margin-left: 0;
  }
}
.level-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  color: #999999;
  cursor: pointer;
  position: relative;
  z-index: 999;
  .triangle {
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #eff7ff;
    border: 1px solid;
    border-color: transparent #328fff #328fff transparent;
    transform: rotate(45deg);
    bottom: -6px;
  }
}
.level-box-active {
  border-color: #328fff;
  color: #328fff;
  background-color: #eff7ff;
}
.level-list {
  margin-top: 16px;
  .item {
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.table {
  margin-top: 16px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  header {
    display: flex;
    align-items: center;
    background-color: #f3f3f6;
    border-bottom: 1px solid #e6e6e6;
    font-weight: 500;
    height: 40px;
  }
  .row {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 54px;
  }
}
::v-deep tbody {
  .el-table__cell {
    padding: 0;
  }
  .no-padding {
    .cell {
      padding: 0;
    }
  }
}
.active-icon-type {
  color: #328fff;
  position: relative;
  &:before {
    content: " ";
    position: absolute;
    left: 34px;
    bottom: -15px;
    width: 28px;
    height: 4px;
    background-color: #328fff;
    border-radius: 2px;
  }
}
.imgList {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  .item {
    font-size: 14px;
    border-radius: 1px;
    border: 1px solid #e5e5e5;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }
  .active {
    border: 1px solid #328fff;
  }
}
.selected-icon {
  position: relative;
  &:hover {
    &:before {
      font-family: "element-icons";
      content: "\e6d7";
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      color: white;
      background-color: rgba(0, 0, 0, 0.54);
    }
  }
}
.warning-icon {
  position: relative;
  &:hover {
    &:before {
      font-family: "element-icons";
      content: "\e6d7";
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      width: 80px;
      height: 80px;
      color: white;
      background-color: rgba(0, 0, 0, 0.54);
    }
  }
}
label.el-form-item__label {
  font-size: 14px;
  color: #999999;
}
.word {
  &:hover {
    color: #328fff;
  }
}
.TipSucc {
  font-size: 14px;
  position: relative;
  &:before {
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    left: -16px;
    top: 4px;
    background: #64b33b;
    border-radius: 50%;
  }
}
.TipFail {
  font-size: 14px;
  position: relative;

  &:before {
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    background: #c1c1c1;
    border-radius: 50%;
    left: -16px;
    top: 4px;
  }
}
.selectShow {
  top: 10px;
  width: calc(100% - 28px);
  padding: 2px 14px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f7f7;
  border-radius: 4px;
}
.risk-measure-items {
  min-width: 0;
}
.risk-measure-entry {
  display: flex;
  align-items: center;
  min-width: 0;
}
.risk-measure-entry + .risk-measure-entry {
  margin-top: 8px;
}
.risk-measure-entry ::v-deep .el-tooltip {
  flex: 1;
  width: 0;
  min-width: 0;
  overflow: hidden;
}
.risk-measure-entry-text {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: #606266 !important;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .risk-measure-tooltip {
  max-width: 500px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.measure-detail-group + .measure-detail-group {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}
.measure-detail-list {
  max-height: 60vh;
  overflow-y: auto;
}
.measure-detail-text {
  overflow-wrap: anywhere;
}
::v-deep .risk-level-cell .cell {
  padding-right: 0;
  padding-left: 0;
}
</style>
